import React from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import { connect } from "react-redux";
import ReactTable from "react-table";
import TablePagination from "components/Table/TablePagination";
import CoreEngine from "../../core/CoreEngine";
import RequestEngine from "../../core/RequestEngine";
import loadingAction from "../../core/redux/actions/loadingAction";
import strings from "../../core/translate";
import { Scopes } from "../../shared/scopes.enum";
import PageHeader from "../../components/Page/PageHeader";

// A fixed, code-defined list: no add or delete here, only turning a method
// on or off — see PaymentMethodController, which has no create/delete route.
class PaymentMethodList extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      dataSource: [],
    };
    this.engine = new RequestEngine();
  }

  componentDidMount() {
    this.callPage();
  }

  callPage = async () => {
    const response = await this.engine.getItem("payment-methods");
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        dataSource: response.data.items.map((item, key) => ({
          id: key,
          data: item,
          name: item.name,
          code: item.code,
          isActive: item.isActive,
        })),
      });
    } else {
      this.setState({ isLoading: false });
    }
    this.props.loadingAction(false);
  };

  handleToggleActive = async (item, checked) => {
    this.props.loadingAction(true);
    await this.engine.updateItem("payment-methods", item.id, {
      version: item.version,
      isActive: checked,
    });
    await this.callPage();
    this.props.loadingAction(false);
  };

  render() {
    const { dataSource, isLoading } = this.state;
    const canWrite = this.hasPermission([Scopes.PAYMENT_METHODS_WRITE]);

    const columns = [
      { Header: strings.name, accessor: "name" },
      { Header: strings.code, accessor: "code" },
      {
        Header: strings.active,
        accessor: "isActive",
        sortable: false,
        filterable: false,
        Cell: (row) => (
          <input
            type="checkbox"
            checked={!!row.value}
            disabled={!canWrite}
            onChange={(e) =>
              this.handleToggleActive(row.original.data, e.target.checked)
            }
          />
        ),
      },
    ];

    return (
      <div className="content">
        <PageHeader
          icon="nc-icon nc-credit-card"
          title={strings.payment_methods}
          subtitle={strings.payment_methods_subtitle}
          count={dataSource.length > 0 ? dataSource.length : undefined}
        />
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <ReactTable
                  previousText={strings.previous}
                  nextText={strings.next}
                  loadingText={strings.loading}
                  noDataText={strings.nodata}
                  pageText={strings.page}
                  data={dataSource}
                  loading={isLoading}
                  columns={columns}
                  defaultPageSize={10}
                  showPaginationTop={false}
                  showPaginationBottom
                  PaginationComponent={TablePagination}
                  className="-striped -highlight primary-pagination"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadingAction: (payload) => dispatch(loadingAction(payload)),
});

export default connect(null, mapDispatchToProps)(PaymentMethodList);
